<template>
    <div>
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <!-- TÍTULO E BREADCRUMB -->
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t("parametrizacoes") }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("b2b")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("parametrizacoes")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>

                    <ul class="nav nav-tabs nav-tabs-children">
                        <li
                            v-for="(aba, i) in abas"
                            :key="i"
                            v-show="listaPermissoes[aba].read"
                            :class="{ active: abaSelecionada == i }"
                            @click="changeTab(i)"
                        >
                            <a data-toggle="tab">{{ $t(aba) }}</a>
                        </li>
                    </ul>

                    <!-- CONJTO DE ABAS - MOBILE -->
                    <b-dropdown aria-role="list" class="mobile-tab-list">
                        <div slot="trigger" class="mobile-tab">
                            <span class="mobile-tab-text">
                                {{ $t(abas[abaSelecionada]) }}
                            </span>
                            <em class="mdi mdi-chevron-down"></em>
                        </div>

                        <b-dropdown-item
                            class="mobile-tab-list-item"
                            :class="{ active: abaSelecionada == i }"
                            aria-role="listitem"
                            v-for="(aba, i) in abas"
                            v-show="listaPermissoes[aba].read"
                            :key="i"
                            @click="changeTab(i)"
                        >
                            {{ $t(aba) }}
                        </b-dropdown-item>
                    </b-dropdown>

                    <Geral
                        ref="tabGeral"
                        v-if="
                            abasAbertas['geral'] &&
                            listaPermissoes['geral'].read
                        "
                        v-show="abas[abaSelecionada] == 'geral'"
                        @isChanged="isChanged = $event"
                    />
                    
                    <Categoria
                        ref="tabCategoria"
                        v-if="
                            abasAbertas['categoria'] &&
                            listaPermissoes['categoria'].read
                        "
                        v-show="abas[abaSelecionada] == 'categoria'"
                        @isChanged="isChanged = $event"
                    />

                    <Segmento
                        ref="tabSegmento"
                        v-if="
                            abasAbertas['segmento'] &&
                            listaPermissoes['segmento'].read
                        "
                        v-show="abas[abaSelecionada] == 'segmento'"
                        @isChanged="isChanged = $event"
                    />

                    <Logistica
                        ref="tabLogistica"
                        v-if="
                            abasAbertas['logistica'] &&
                            listaPermissoes['logistica'].read
                        "
                        v-show="abas[abaSelecionada] == 'logistica'"
                        @isChanged="isChanged = $event"
                    />

                    <Banner
                        ref="tabBanner"
                        v-if="
                            abasAbertas['banner'] &&
                            listaPermissoes['banner'].read
                        "
                        v-show="abas[abaSelecionada] == 'banner'"
                        @isChanged="isChanged = $event"
                    />
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import Categoria from "@/components/b2b/parametrizacoes/abas/Categoria";
import Segmento from "@/components/b2b/parametrizacoes/abas/Segmento"; 
import Geral from "@/components/b2b/parametrizacoes/abas/Geral"; 
import Logistica from "@/components/b2b/parametrizacoes/abas/Logistica"; 
import Banner from "@/components/b2b/parametrizacoes/abas/Banner"; 

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("parametrizacoes") && to.name != "b2b-parametrizacoes-edit") {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            next();
        }
    },
    components: {
        ContainerLoader,
        Categoria,
        Segmento,
        Geral,
        Logistica,
        Banner
    },
    data() {
        return {
            isLoading: false,
            permissao: {},
            abaSelecionada: 0,
            abas: [
                "geral",
                "categoria",
                "segmento",
                "logistica",
                "banner"
            ],
            abasAbertas: {},
            listaPermissoes: {}
        };
    },
    created() {
        if (
            this.$route.name.includes("parametrizacoes") &&
            this.$route.name != "b2b-parametrizacoes-edit"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        this.permissao = this.hasPermissionAccess(
            "b2b",
            "b2b-parametrizacoes-edit"
        );

        if (
            !this.permissao.create ||
            !this.permissao.read
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "b2b" },
            });
        } else {
            for (let [key, value] of Object.entries(this.abas)) {
                this.abasAbertas[value] = false;
                this.listaPermissoes[value] = this.hasPermissionAccess(
                    "b2b",
                    `b2b-parametrizacoes-edit`
                );
            }

            for (let [key, value] of Object.entries(this.listaPermissoes)) {
                if (value.read) {
                    this.abaSelecionada = this.abas.findIndex((e) => e == key);
                    this.abasAbertas[key] = true;
                    break;
                }
            }
        }
    },
    methods: {
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada]] = true;
        },
    }
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;
}
.page {
    position: relative;
    padding-left: 0;

    .nav-tabs-children {
        margin-bottom: 20px;
        li > a {
            text-transform: capitalize;
        }
        li > ::after {
            bottom: -4px;
            border-width: 2px;
        }
    }

    .mobile-tab {
        cursor: pointer;

        &-list {
            width: calc(100% + 40px);
            margin-top: 20px;
            margin-bottom: 20px;
            margin-left: -20px;
            padding-right: 20px;
            padding-bottom: 5px;
            padding-left: 20px;
            border-bottom: 1px solid $table-border;
            justify-content: center;

            &::after {
                content: "";
                border: 3px solid $primary-color-click;
                border-radius: 100px;
                position: absolute;
                width: calc(100% - 40px);
                bottom: -3px;
            }

            &-item {
                text-transform: uppercase;
                font-weight: 600;
                color: $text-color;

                &.active {
                    color: $primary-color-click;
                }
            }
        }

        &-text {
            text-transform: uppercase;
            font-weight: 600;
            color: $primary-color-click;

            & ~ i {
                color: $primary-color-click;
            }
        }
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
</style>
